<template>
  <div>
    <div class="app-showcase-process-step__one mb-40">
      <div class="container-fluid container-fluid--cp-150">
        <div class="row flex-column-reverse flex-lg-row align-items-center">
          <div class="col-lg-5">
            <div class="app-showcase-process-step__media text-center wow move-up">
              <img :src="img" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-7">
            <div class="app-showcase-process-step__content section-space--mt_40">
              <div class="app-showcase__inner">
                <h4 class="font-weight--light wow move-up mb-40">Reset Password</h4>
                <div class="sub-text section-space--mb_40 wow move-up">
                  An email with a verification code has been sent. If you don't see an email, please
                  check your spam folder.
                </div>

                <div class="wow move-up">
                  <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group id="input-group-1" label="Verification Code:" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="$v.form.token.$model"
                        :state="validateState('token')"
                        aria-describedby="input-1-live-feedback"
                        type="text"
                        class="form-input"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback"
                        >Verification code is required.
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      id="input-group-2"
                      label="New Password:"
                      label-for="input-2"
                      description="Use 8 or more characters with a mix of letters numbers & symbols."
                    >
                      <b-form-input
                        id="input-2"
                        v-model="$v.form.password.$model"
                        :state="validateState('password')"
                        aria-describedby="input-2-live-feedback"
                        type="password"
                        class="form-input"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback"
                        >Password does not meet minimum requirements.
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      id="input-group-3"
                      label="Confirm New Password:"
                      label-for="input-3"
                    >
                      <b-form-input
                        id="input-3"
                        v-model="$v.form.confirmPassword.$model"
                        :state="validateState('confirmPassword')"
                        aria-describedby="input-3-live-feedback"
                        type="password"
                        placeholder=""
                        class="form-input"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-3-live-feedback"
                        >Passwords do not match.
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="btn-sowcase section-space--mb_40 wow move-up">
                      <b-button type="submit" variant="primary" class="scroll btn btn--green"
                        >Change Password</b-button
                      >
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'

import FooterMain from '@/components/FooterMain'

const passwordReq = helpers.regex(
  'passwordReq',
  /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/
)

import { handleGlobalError } from '../util'
export default {
  name: 'RegisterScreen',
  mixins: [validationMixin],
  components: {
    FooterMain,
  },
  data() {
    return {
      loading: false,
      img: require('../assets/img/hero/startup/top.png'),
      form: {
        email: '',
        password: '',
        confirmPassword: '',
      },
      show: true,
    }
  },
  validations: {
    form: {
      token: {
        required,
      },
      password: {
        required,
        passwordReq,
        minLength: minLength(8),
      },
      confirmPassword: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
  async mounted() {
    if (this.$store.getters.user) {
      this.$router.push('/profile')
    }
  },
  computed: {
    email() {
      return this.$store.getters.email
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'resetPwdShort',
          value: {
            user: { email: this.$store.getters.email },
            token: this.form.token,
            password: this.form.password,
          },
        })
        // alert(JSON.stringify(user))
        this.$router.push({ path: `change-password-success` })
      } catch (error) {
        console.error('error changing password', error)
        handleGlobalError(this, error, 'changing password')
      }
    },
    successPasswordToast() {
      this.$bvToast.toast('Password has been successfully changed!', {
        title: 'Password Change Success!',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
    onReset(event) {
      event.preventDefault()
      // Reset  form values
      this.form.email = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>
